import { Modal, Text, View, type GestureResponderEvent } from 'react-native';
import { PrimaryButton, SecondaryButton } from 'src/presentation/components/molecules/Button';
import dialogStyles from 'src/presentation/dialogs/styles/DialogStyles';
import Dimens from 'src/core/utils/Dimens';

interface Props {
	buttonText?: string;
	buttonTextVerify?: string;
	isLoading?: boolean;
	onPress: (event: GestureResponderEvent) => void;
	onPressVerify?: (event: GestureResponderEvent) => void;
	text?: string;
	title?: string;
	visible?: boolean;
}

const VerifyDialog = ({
	buttonText,
	buttonTextVerify,
	isLoading = false,
	onPress,
	onPressVerify,
	text,
	title,
	visible,
}: Props) => {
	return (
		<Modal animationType="fade" style={dialogStyles.modalView} transparent={true} visible={visible}>
			<View style={dialogStyles.centeredView}>
				<View style={dialogStyles.modalCard}>
					<Text style={dialogStyles.modalTitle}>{title}</Text>
					<Text style={dialogStyles.modalDescription}>{text}</Text>

					<PrimaryButton
						extraStyle={{ marginBottom: Dimens.padding10 }}
						label={buttonTextVerify}
						loading={isLoading}
						onPress={onPressVerify}
					/>
					<SecondaryButton label={buttonText} onPress={onPress} />
				</View>
			</View>
		</Modal>
	);
};

export default VerifyDialog;
